import { Subscription, Subject } from 'rxjs';
import { SLLayer } from './sl-layer';
import { ResultMoment, ResultsSelectionMode } from '../services/results.service';

export type SynchId = string;
export type SynchHandler = (event: SynchEvent) => void;
export interface Synchable {
	synchId: SynchId;
	synchables: Array<SynchId>;
	channel?: number | string;
	handler: SynchHandler;
	subscription?: Subscription;
	currentLayer?: SLLayer;
	featureIndex?: number;
	currentFeature?: any;
	selections?: { selected: Array<string | number>, unselected: Array<string | number> }
}

export interface IIgnorableSynchEvent {
	source: SynchId;
	topic: string;
	channel?: number | string;
	data?: any;
}

export interface ISelectionInfo {
	id: string;
	layerId: any;
	layer: any;
	selectionMode: ResultsSelectionMode;
	features?: Array<string>;
	unfeatures?: Array<string>;
}

export interface SynchEvent {
	source: SynchId;
	channel: number | string;
	topic: string;
	data: any;
	synchFrom?: string;
	synchTo?: string;
	ignoreList?: Array<IIgnorableSynchEvent>;
	synchronizing?: boolean;
}
export interface ISelectionData {
	moment: ResultMoment;
	selections: ISelectionInfo;
}
export interface SynchSelectionsEvent extends SynchEvent {
	source: SynchId;
	channel: number | string;
	topic: string;
	data: ISelectionData;
	ignoreList?: Array<IIgnorableSynchEvent>
}

export class Synchronizer {
	private syncher: Subject<SynchEvent>;
	private synchables: Array<Synchable>;
	constructor() {
		this.syncher = new Subject<SynchEvent>();
		this.synchables = [];
	}

	AddSynchable(synchable: Synchable): Subscription {
		this.synchables.push(synchable);
		synchable.subscription = this.syncher.subscribe(synchable.handler)
		return synchable.subscription;;
	}
	RemoveSynchable(synchable: Synchable, subscription: Subscription) {
		let i = -1;
		for (const synch of this.synchables) {
			i++;
			if (synch.synchId === synchable.synchId) {
				this.synchables.splice(i, 1);
			}
		}
		subscription.unsubscribe();
	}
	SynchChannels(target: SynchId | Synchable, from: SynchId | Synchable, event?: SynchEvent): boolean {
		if (typeof target === 'string') {
			target = this.GetSynchable(target);
		}
		if (typeof from === 'string') {
			from = this.GetSynchable(from);
		}
		if (target.hasOwnProperty('channel')) {
			if (!!from) {
				if (from.hasOwnProperty('channel')) {
					target.channel = from.channel;
					if (!!event) {
						this.syncher.next(event);
						return true;
					}
				}
			}
		}
		return false;

	}
	GetSynchable(synchId: SynchId): Synchable | null {
		for (const synch of this.synchables) {
			if (synch.synchId === synchId) {
				return synch;
			}
		}
		return null;
	}
	Synch(event: SynchEvent) {
		const topicParts: Array<string> = event.topic.trim().split(' ');

		if (topicParts.length === 4) {
			if (topicParts[0] === 'synch') {
				const [fromId, direction, toId] = topicParts.slice(1);

				switch (direction) {
					case 'to':
						event.topic = 'request-synch'
						event.synchFrom = fromId;
						event.synchTo = toId;
						this.SynchChannels(toId, fromId, event);
						break;
					case 'from':
						event.topic = 'request-synch';
						event.synchFrom = toId;
						event.synchTo = fromId;
						this.SynchChannels(fromId, toId, event);
						break;
				}
				return;
			}
		} else {
			if (!!event.synchTo) {
				const targets = event.synchTo.split(',');
				let i = -1;
				for (const synchable of this.synchables) {
					if (targets.indexOf(synchable.synchId) > -1) {
						i++;
						event.synchTo = synchable.synchId;
						synchable.handler(event);
					}
				}
				if (i >= 0) {
					return;
				}
			}
		}
		this.syncher.next(event);
	}

}

